import {
  ChangeDetectorRef,
  Component,
  NgZone,
  OnDestroy,
  ViewChild,
  HostListener,
  Directive,
  AfterViewInit,
  ViewRef,
} from "@angular/core";
import { MediaMatcher } from "@angular/cdk/layout";
import { MenuItems } from "../../../shared/menu-items/menu-items";
import { StreamService } from "../../../shared/stream.service";
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})
export class AppSidebarComponent implements OnDestroy {
  mobileQuery: MediaQueryList;
  isLoading: boolean = true;
  subscribedPage: any;
  NewOrder: any;
  private _mobileQueryListener: () => void;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    public menuItems: MenuItems,
    public streamService: StreamService
  ) {
    this.subscribedPage = this.streamService
      .getFilterSubscription()
      .subscribe((data: any) => {
        console.log("indside meeee side Bar", data);
        this.NewOrder = data;
      });
    this.mobileQuery = media.matchMedia("(min-width: 768px)");
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  active(index) {
    console.log("active");
    setTimeout(() => {
      console.log(index);
      localStorage.setItem("activeIndex", index);
      this.detectChanges();
      this.ngOnDestroy();
    }, 280);
  }
  readLocalStorageValue(key: string): number {
    return parseInt(localStorage.getItem(key));
  }

  activeRoute(index) {
    localStorage.setItem("activeIndex", index);
  }
  detectChanges() {
    console.log("CHanges");
    // Programmatically run change detection to fix issue in Safari
    setTimeout(() => {
      // this.isLoading = true;
      if (
        this.changeDetectorRef !== null &&
        this.changeDetectorRef !== undefined &&
        !(this.changeDetectorRef as ViewRef).destroyed
      ) {
        this.changeDetectorRef.detectChanges();
        // this.isLoading = false;
      }
    }, 580);
  }

  ngOnDestroy(): void {
    console.log("DESTROY");
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
